/*
 * Module for handling of ajax navigation links
 */
rs.module("content/system/configuration/insurancesubsidytables/edit",

    ["controls/components/event-banner"],

    function (eventBanner) {

        var _executeSelectionChanged;

        // initialize the module
        function initialize(jsSelectors, columnIds, grid, ajaxUrl) {

            // This page either has two edit forms (paramsForm and detailsForm) or one addForm containing the same content
            var addForm = $.js(jsSelectors.addForm, { required: false });
            var detailsForm = $.js(jsSelectors.detailsForm, { required: false });

            var tableDetailKey = detailsForm.length > 0 ? detailsForm.js(jsSelectors.tableDetailKey) : addForm.js(jsSelectors.tableDetailKey);
            var minYearsService = detailsForm.length > 0 ? detailsForm.js(jsSelectors.minYearsService) : addForm.js(jsSelectors.minYearsService);
            var subsidyPercentage = detailsForm.length > 0 ? detailsForm.js(jsSelectors.subsidyPercentage) : addForm.js(jsSelectors.subsidyPercentage);
            var effectiveDate = detailsForm.length > 0 ? detailsForm.js(jsSelectors.effectiveDate) : addForm.js(jsSelectors.effectiveDate);
            var terminationDate = detailsForm.length > 0 ? detailsForm.js(jsSelectors.terminationDate) : addForm.js(jsSelectors.terminationDate);
            var detailUpdateToken = detailsForm.length > 0 ? detailsForm.js(jsSelectors.detailUpdateToken) : addForm.js(jsSelectors.detailUpdateToken);

            // these two controls only exist in edit mode
            var addDetailLink = detailsForm.js(jsSelectors.addDetailLink, { required: false });
            var cancelDetailButton = detailsForm.js(jsSelectors.cancelDetailButton, { required: false });

            if (grid) {
                addDetailLink.on("click", addDetailClicked);
                cancelDetailButton.on("click", cancelDetailClicked);

                grid.selectionChanged(function (values, rows) {

                    // This handler fires when the grid is first rendered, but we don't want it to in our case
                    // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                    if (_executeSelectionChanged && values.length > 0) {
                        eventBanner.removeAllMessages();

                        $.get(
                            ajaxUrl,
                            { tableDetailKey: rows[0][columnIds.tableDetailKey] },

                            function (data) {
                                minYearsService.val(data.minimumYearsService).clearErrors();
                                subsidyPercentage.val(data.subsidyPercentage).clearErrors();
                                effectiveDate.val(data.effectiveDate ? new Date(data.effectiveDate).toISODateString() : null).clearErrors();
                                terminationDate.val(data.terminationDate ? new Date(data.terminationDate).toISODateString() : null).clearErrors();
                                tableDetailKey.val(data.graduatedSubsidyTableDetailKey);
                                detailUpdateToken.val(data.updateToken);
                            }
                        );
                    }

                    _executeSelectionChanged = true;
                });

                // clear errors, current values, and grid selection when the add detail button is clicked
                function addDetailClicked() {
                    eventBanner.removeAllMessages();

                    minYearsService.val('').clearErrors();
                    subsidyPercentage.val('').clearErrors();
                    effectiveDate.val('').clearErrors();
                    terminationDate.val('').clearErrors();
                    tableDetailKey.val(-1);

                    grid.selectedValues = null;
                }

                // clear errors and reset grid selection to first row
                function cancelDetailClicked() {
                    eventBanner.removeAllMessages();

                    minYearsService.val('').clearErrors();
                    subsidyPercentage.val('').clearErrors();
                    effectiveDate.val('').clearErrors();
                    terminationDate.val('').clearErrors();
                    tableDetailKey.val(-1);

                    grid.selectedValues = null;
                    grid.selectFirstRow();
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);